import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './guard/auth.guard'; //   canActivate: [AuthGuard]
const appRoutes: Routes = [

    {
        path: '',
        loadChildren: './main/authentication/login-2/login-2.module#Login2Module'
    },
    /*{
       path: 'register-2',
       loadChildren: './main/authentication/register-2/register-2.module#Register2Module'
   }, */
    {
        path: 'vendor',
        loadChildren: './main/vendor/vendor.module#VendorModule',
        canActivate: [AuthGuard]
    },
    {
        path: 'company',
        loadChildren: './main/company/company.module#CompanyModule',
        canActivate: [AuthGuard]
    },
    {
        path: 'bothcompanyvendor',
        loadChildren: './main/bothcompanyvendor/bothcompanyvendor.module#bothCompanyVendorModule',
        canActivate: [AuthGuard]
    },
    {
        path: 'forgot-password-2',
        loadChildren: './main/authentication/forgot-password-2/forgot-password-2.module#ForgotPassword2Module',
        // canActivate: [AuthGuard]
    }, {
        path: 'login-2',
        loadChildren: './main/authentication/login-2/login-2.module#Login2Module',
    },
    {
        path: 'token-verification',
        loadChildren: './main/authentication/token-verification/token-verification.module#TokenVerificationModule',   
    },
    {
        path: 'pricing',
        loadChildren: './main/authentication/coming-soon/coming-soon.module#ComingSoonModule',
        canActivate: [AuthGuard]
    },
    {
        path: 'pages',
        loadChildren: './main/pages/pages.module#PagesModule',
        canActivate: [AuthGuard]
    },
    {
        path: 'chat',
        loadChildren: './main/chat/chat.module#ChatModule',
        canActivate: [AuthGuard]
    },
    {
        path: 'mail',
        loadChildren: './mail/mail.module#MailModule',
        canActivate: [AuthGuard]
    },
    {
        path: 'vendor-mail',
        loadChildren: './vendor-mail/mail/mail.module#MailModule',
        canActivate: [AuthGuard]
    },
    {
        path: '**',
        redirectTo: 'login-2'
    }
];



@NgModule({
    imports: [RouterModule.forRoot(appRoutes, { useHash: true })],
    exports: [RouterModule]
})
export class AppRoutingModule { }
